var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"passenger-seg-list"},[_vm._l((_vm.passegnersArray),function(passenger,index){return [_c('passenger-box',_vm._g(_vm._b({key:index,attrs:{"passenger":passenger,"index":index,"order":_vm.order,"cmsData":_vm.cmsData},on:{"select":_vm.selectHandler}},'passenger-box',_vm.$attrs,false),_vm.$listeners))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }